import { render, staticRenderFns } from "./AtcFormSecondaryButton.vue?vue&type=template&id=d27e6ec2&scoped=true&"
import script from "./AtcFormSecondaryButton.vue?vue&type=script&lang=js&"
export * from "./AtcFormSecondaryButton.vue?vue&type=script&lang=js&"
import style0 from "./AtcFormSecondaryButton.vue?vue&type=style&index=0&id=d27e6ec2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27e6ec2",
  null
  
)

export default component.exports